export const isWebAuthnSupported = (): boolean => {
  return !!(window.PublicKeyCredential && navigator.credentials && navigator.credentials.get);
};

export type OperatingSystem = 'ios' | 'android' | 'desktop' | 'generic';

export const getOperatingSystem = (): OperatingSystem => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return 'ios';
  }

  if (
    /Windows NT|Macintosh|X11/.test(userAgent) ||
    (!/Mobi|Android/.test(userAgent) && /Linux/.test(userAgent))
  ) {
    return 'desktop';
  }

  return 'generic';
};
